export const sanitiseMarkdownString = (markdown: string) => {
  const plainText = markdown
    .replace(/\[(.*?)\]\(.*?\)/g, '$1') // Remove hyperlinks
    .replace(/[#*]/g, '') // Remove headings and bold/italic formatting
    .replace(/`.*?`/g, '') // Remove code blocks

  return plainText
}
